<template>
  <artmisads-modal :open="true" :title="st('campaigns.placementPaymentModalTitle')" :width="720"
    :onCancel="() => props.setDetailData('hideInvoiceModal', 'invoice')" :destroyOnClose="true">
    <a-spin :spinning="spinning">
      <div class="invoice">
        <!-- <div class="head">
          <span class="name">Statement Amount:</span>
          <div class="text">
            <span class="num">{{ selectedTotalPaymentAmount }}</span>
          </div>
          
        </div> -->
        <div class="method">
          <method :methodType="methodType" :setMethodType="setMethodType" />
        </div>
        <!-- <div class="main-cont" v-if="methodType === 'bank'">
          <p class="notice">Please fill in the relevant information after completing the bank transfer.</p>
          <div class="input-wrap">
            <a-form>
              <a-form-item name="bankAccountName" v-bind="validateInfos.bankAccountName">
                <div class="input-item">
                  <span class="text">Bank Account Name<span>*</span></span>
                  <artmisads-input style="width: 324px;" @blur="() => validate('bankAccountName')" size="middle"
                    v-model:value="modelRef.bankAccountName" />
                </div>
              </a-form-item>
            </a-form>
            <a-form>
              <a-form-item name="bankTransferNo" v-bind="validateInfos.bankTransferNo">
                <div class="input-item">
                  <span class="text">Bank Transfer NO.<span>*</span></span>
                  <artmisads-input style="width: 324px;" @blur="() => validate('bankTransferNo')" size="middle"
                    v-model:value="modelRef.bankTransferNo" />
                </div>
              </a-form-item>
            </a-form>
          </div>
          <p class="img-notice">Upload Transfer receipt photo</p>
          <div class="upload-img">
            <a-form :label-col="{ style: { width: '60px' } }" :wrapper-col="{ span: 20 }" layout="horizontal"
              style="color: aquamarine">
              <a-form-item>
                <UploadImage :configs="{
                  maxCount: 1,
                  maxSize: 2,
                  spin: true,
                }" @upload-file="uploadImg" #content>
                  <div class="upload_part">
                    <div v-if="bankTransferReceiptImageUrl" class="upload-img">
                      <img :src="imgCache(bankTransferReceiptImageUrl)" alt="" />
                    </div>
                    <div v-else class="upload-icon">
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-shangchuan-xi"></use>
                      </svg>
                    </div>
                  </div>
                </UploadImage>
              </a-form-item>
            </a-form>
          </div>
          <p class="note">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-info"></use>
            </svg>
            For bank transfer, after you submit the transfer information, the payment status will be updated after the
            ArtemisAds operation team verifies the transfer result.
          </p>
        </div> -->
        <div class="pay-cont-wrap">
          <payCont :payInfo="payInfo" :methodType="methodType" />
        </div>
      </div>
    </a-spin>
    <template #footer>
      <div class="invoice-btn">
        <artmisads-button class="cancel-btn"
          @click="() => props.setDetailData('hideInvoiceModal', 'invoice')">{{ st('common.cancel') }}</artmisads-button>
        <artmisads-button type="primary" @click="financeSellerBillingsSubmit">{{ st('common.submit') }}</artmisads-button>
      </div>
    </template>
  </artmisads-modal>
  <OrderExistedTipModal v-if="showOrderExistedTipModal" :orderList="existedOrderList"
    @createNewOrder="financeSellerBillingsSubmit" :hideOrderExistedTipModal="() => showOrderExistedTipModal = false" />
</template>

<script setup>
import moment from 'moment';
import method from './method.vue'
import { imgCache } from '~/utils'
import payCont from './payCont.vue'
import { Form } from 'ant-design-vue';
import { financeApi } from "~/server";
import { useRouter } from "vue-router";
import { message } from 'ant-design-vue';
import { ref, reactive, computed, onBeforeMount } from "vue";
import { useUserInfoStore } from "~/storeData/index";
import { useSellerI18n } from '@/composables/useSellerI18n';
import UploadImage from '@/components/uploadImage.vue'
import OrderExistedTipModal from './OrderExistedTipModal.vue'
import { CURRENCY_DATA_MAPPER, AMAZON_CURRENCY_MAPPER } from "~/contants/common";

const router = useRouter();
const { st } = useSellerI18n();
const spinning = ref(false);
const store = useUserInfoStore();
const existedOrderList = ref([]); // 已存在的订单列表
const selectedTotalPaymentAmount = ref(0); // 选中的待支付总金额
const showOrderExistedTipModal = ref(false); // 是否显示订单已存在提示弹窗
const methodType = ref(store.userInfo.countryCode === 'US' ? 'aliPay_cn' : 'paypal'); // 支付方式
const props = defineProps(["payOrderList", 'setDetailData', 'hasCompleteInfo', 'setShowNotice']);

const payInfo = ref({
  alipayCnAmountToPay: {},
  alipayCnFeeNotice: {},
  cardAmountToPay: {},
  cardFeeNotice: {},
  paypalAmountToPay: {},
  paypalFeeNotice: {},
})

const columns = computed(() => [
  {
    key: 'billingDate',
    title: st('finance.billingDate'),
    dataIndex: 'billingDate',
  },
  {
    title: st('finance.colTransactionCycle'),
    key: 'transactionCycleStartDate',
    dataIndex: 'transactionCycleStartDate',
  },
  {
    key: 'amount',
    title: st('finance.colAmount'),
    dataIndex: 'amount',
    customRender: ({ text, record }) => {
      return CURRENCY_DATA_MAPPER[record.currency] + text;
    }
  },
  {
    title: st('finance.colPending'),
    key: 'paymentPendingAmount',
    dataIndex: 'paymentPendingAmount',
    customRender: ({ text, record }) => {
      return CURRENCY_DATA_MAPPER[record.currency] + text;
    }
  },
  {
    key: 'downloadInvoice',
    title: st('finance.btnInvoice'),
  },
])

const modelRef = reactive({
  bankTransferNo: '',
  bankAccountName: '',
});

const bankTransferReceiptImageUrl = ref('');

// 如果只有一条数据，则直接赋值
// if (props.payOrderList.length === 1) {
//   const { bankAccountName, bankTransferNo } = props.payOrderList[0];

//   modelRef.bankTransferNo = bankTransferNo;
//   modelRef.bankAccountName = bankAccountName;
//   bankTransferReceiptImageUrl.value = props.payOrderList[0].bankTransferReceiptImageUrl;
// }

const useForm = Form.useForm;

const rulesRef = reactive({
  bankAccountName: [{
    required: true,
    message: st('finance.invoiceFormRequiredMessage'),
    trigger: ['blur']
  }],
  bankTransferNo: [{
    required: true,
    message: st('finance.invoiceFormRequiredMessage'),
    trigger: ['blur']
  }]
});

const { validate, validateInfos } = useForm(modelRef, rulesRef);

const uploadImg = (res) => {
  try {
    if (res.data.url) {
      bankTransferReceiptImageUrl.value = res.data.url;
    }
  } catch (error) {
    console.log('upload-false')
  }
}

const setMethodType = status => {
  methodType.value = status;
}

const financeSellerBillingsSubmit = async (checkOrder = true) => {
  let validateRes = {};

  // 检查是否存在待支付的订单
  if (checkOrder) {
    const checkExistedOrderRes = await financeApi.checkExistedPendingOrder({ billingIds: props.payOrderList.invoiceNo,billingBusinessSource:"placement" });
    const { data } = checkExistedOrderRes;
    if (data?.length) {
      existedOrderList.value = data;
      showOrderExistedTipModal.value = true;
      return;
    }
  } else {
    showOrderExistedTipModal.value = false;
  }

  // 如果选择的是银行转账，则需要验证银行信息
  if (methodType.value === 'bank') {
    validateRes = await validate();
  }

  if (!validateRes?.errorFields || methodType.value !== 'bank') {
    let paramsData = { ...validateRes, billingIds: [props.payOrderList.invoiceNo], paymentMethod: methodType.value.toUpperCase(),billingBusinessSource:"placement" };

    // 如果选择的是银行转账，则需要上传银行转账凭证
    if (methodType.value === 'bank') {
      paramsData.bankTransferReceiptImageUrl = bankTransferReceiptImageUrl.value || '';
    }

    spinning.value = true;
    const res = await financeApi.payBillings(paramsData);
    const { success, data } = res;

    if (success) {
      if (data.paymentUrl) {
        localStorage.setItem('SELLER_ORDER_REQUESTID', data.requestId);
        window.open(data.paymentUrl, '_blank');
      }

      props.setDetailData(null, 'invoice', true);
    } else {
      if (res.error) {
        message.error(res.error);
      }
    }

    spinning.value = false;
  }
}

// 获取费率
const financeSellerPaymentAlipayPaymentAmountWithFees = () => {
  spinning.value = true;

  financeApi.financeSellerPaymentAlipayPaymentAmountWithFees({
    billingIds: props.payOrderList.invoiceNo,
    billingBusinessSource:"placement"
  }).then(res => {
    const { success, data } = res;

    if (success) {
      payInfo.value = data;
    }

    spinning.value = false;
  })
};



onBeforeMount(() => {
  console.log(props.payOrderList, 'props.payOrderList')
  financeSellerPaymentAlipayPaymentAmountWithFees()
  selectedTotalPaymentAmount.value = CURRENCY_DATA_MAPPER[props.payOrderList.currency] + props.payOrderList.amount;
})
</script>

<style lang="less" scoped>
.invoice-btn {
  display: flex;

  .cancel-btn {
    border: none;
    background-color: var(--bg-gray-6);

    &:hover {
      background-color: var(--bg-gray-4);
    }
  }

  #paypal-button-container {
    height: 40px;
    margin-left: 8px;
  }
}

.invoice {

  .main-cont {
    margin-top: 12px;
  }

  .paypal-text {
    font-weight: 600;
    font-size: 16px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 24px;
  }

  .method {
    margin-top: 30px;
  }

  .head {
    background: var(--bg-gray-1);
    border-radius: 8px;
    padding: 12px 8px 12px 12px;

    .name {
      font-weight: 500;
      font-size: 13px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 20px;
    }

    .text {
      display: flex;
      justify-content: space-between;

      .num {
        font-weight: 600;
        font-size: 18px;
        color: var(--dark-1);
        letter-spacing: 0.4px;
        line-height: 24px;
        margin-top: 6px;
        margin-bottom: 8px;
      }

      button {
        display: flex;

        svg {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          align-self: center;
        }
      }
    }
  }

  .pay-cont-wrap {
    margin-top: 30px;
  }

  .notice {
    font-weight: 600;
    font-size: 16px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 24px;
  }

  .input-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;

    :deep(.ant-form-item) {
      margin-bottom: 0;
    }

    .input-item {
      display: flex;
      flex-wrap: wrap;
      width: 308px;

      .text {
        color: var(--dark-2);
        font-weight: 500;
        line-height: 18px;
        font-size: 13px;
        margin-bottom: 4px;
        display: flex;

        >span {
          color: var(--red-text);
          margin-left: 3px;
          font-size: 14px;
          font-weight: 600;
          line-height: 18px;
        }
      }
    }
  }

  .img-notice {
    color: var(--dark-2);
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.3px;
    line-height: 18px;
    margin-top: 24px;
  }

  .note {
    line-height: 18px;
    color: var(--dark-3);
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 0.3px;
    margin-top: 40px;

    svg {
      width: 14px;
      height: 14px;
      fill: var(--dark-3);
      margin-right: 1px;
      vertical-align: -3px;
    }
  }

  .note-paypal {
    margin-top: 12px;
  }

  .upload-img {
    margin-top: 4px;

    >img {
      width: 120px;
      height: 120px;
      object-fit: contain;
    }

    :deep(.ant-upload) {
      background-color: var(--bg-gray-6);
      width: 120px;
      height: 120px;
      border-radius: 8px;
      cursor: pointer;

      .upload_part {
        width: 120px;
        height: 120px;
      }

      .upload-icon {
        display: flex;
        justify-content: center;
        height: 100%;

        svg {
          align-self: center;
          width: 32px;
          height: 32px;
          fill: var(--dark-3);
        }
      }
    }
  }
}

.billing-table {
  overflow: hidden;
  padding-bottom: 0;
  border-radius: 8px;
  border: 1px solid var(--border-4);

  :deep(.icon-daochu1) {
    cursor: pointer;
    font-size: 18px;
    margin-left: 12px;
  }

  :deep(.ant-table) {
    table {
      background: var(--bg-gray-1);
    }

    &-tbody {
      tr:last-child>td {
        border-bottom: none !important;

        &:last-child {
          border-bottom-right-radius: 8px;
        }

        &:first-child {
          border-bottom-left-radius: 8px;
        }
      }

      td {
        background-color: #fff;


      }
    }
  }
}
</style>
